import React from "react";
import { BarChart3Icon, CheckIcon, FileTextIcon, GraduationCapIcon, ListChecksIcon, PaletteIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { extras, volumes } from "../../data/content";
const extraIcons = [FileTextIcon, ListChecksIcon, GraduationCapIcon, BarChart3Icon, PaletteIcon];
export function WhatsInside() {
  return <Section tone="cream" data-id="element-260" data-mp="1cjy8l51fk7cs">
      <SectionHeading kicker="What's inside" data-id="element-261" data-mp="1ck80iy61col4">
        Nail Course In A Box™: <em className="text-berry" data-id="element-262" data-mp="17isf34zy4g27">6 premium volumes</em>
      </SectionHeading>

      <ol className="mt-10 space-y-5" data-id="element-263" data-mp="12k7fn7siq0et">
        {volumes.map(v => <li key={v.number} className="rounded-3xl border border-petal bg-white p-5 md:p-8" data-id="element-264" data-mp="12mk3u2ovd70b">
            <div className="flex items-start gap-4" data-id="element-265" data-mp="xo0h402gbr6w">
              <span className="flex h-14 w-14 shrink-0 flex-col items-center justify-center rounded-2xl bg-berry text-white" data-id="element-266" data-mp="2wxp20rh6sr89">
                <span className="text-[9px] font-bold uppercase tracking-wider text-petal" data-id="element-267" data-mp="2s0gionkayh5f">Vol</span>
                <span className="font-serif text-[20px] font-bold leading-none" data-id="element-268" data-mp="1kndg2bknyspd">{v.number}</span>
              </span>
              <h3 className="font-serif text-[22px] font-bold leading-tight text-ink md:text-[26px]" data-id="element-269" data-mp="1plexks2fyjyq">{v.title}</h3>
            </div>
            <p className="mt-4 text-[16px] leading-relaxed text-muted" data-id="element-270" data-mp="1fp25tzqgig6m">{v.description}</p>
            <p className="mt-5 text-[13px] font-bold uppercase tracking-[0.12em] text-berry" data-id="element-271" data-mp="23emn8e6yp5ds">Inside:</p>
            <ul className="mt-3 flex flex-wrap gap-2" data-id="element-272" data-mp="28eshm24m95zk">
              {v.inside.map(item => <li key={item} className="flex items-center gap-1.5 rounded-full bg-blush px-3 py-1.5 text-[13.5px] font-medium text-ink" data-id="element-273" data-mp="1tpwfsmt5kp7e">
                  <CheckIcon className="h-3.5 w-3.5 text-berry" strokeWidth={3} aria-hidden="true" data-id="element-274" data-mp="2meaaasl193e7" />
                  {item}
                </li>)}
            </ul>
          </li>)}
      </ol>

      <div className="mt-14" data-id="element-275" data-mp="310za6vj75il4">
        <h3 className="text-center font-serif text-[26px] font-bold text-ink md:text-4xl" data-id="element-276" data-mp="3107fro1c5qwf">And you'll also get…</h3>
        <ul className="mt-8 divide-y divide-petal rounded-3xl bg-white px-5 md:px-8" data-id="element-277" data-mp="2vzjp53h0rc2q">
          {extras.map((e, i) => {
          const Icon = extraIcons[i];
          return <li key={e.title} className="flex items-start gap-4 py-5" data-id="element-278" data-mp="2n0g3brqgwikj" data-mpi={i}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-blush text-berry" data-id="element-279" data-mp="2i2wreyh8shvr">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-280" data-mp="2d9lj0sws7t1q" />
                </span>
                <div data-id="element-281" data-mp="28cv3c6ow2zgu">
                  <p className="text-[15px] font-extrabold uppercase tracking-wide text-ink" data-id="element-282" data-mp="28cbioi7utwz4">{e.title}</p>
                  <p className="mt-1 text-[15px] leading-relaxed text-muted" data-id="element-283" data-mp="248dkqau9ms7n">{e.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-10 rounded-3xl bg-berryDark p-6 text-center text-white md:p-10" data-id="element-284" data-mp="1udbypnvae69a">
          <p className="text-[15px] text-petal" data-id="element-285" data-mp="9t6ri83847za">Everything is designed to help you go from:</p>
          <p className="mt-2 font-serif text-[22px] italic text-white/80 line-through decoration-petal/70" data-id="element-286" data-mp="esjlrdwfchbw">
            “I need to create a course.”
          </p>
          <p className="mt-2 text-[15px] text-petal" data-id="element-287" data-mp="nu112u20cezj">to:</p>
          <p className="mt-2 font-serif text-[24px] font-bold leading-snug md:text-3xl" data-id="element-288" data-mp="nthj5dccxqli">
            “I already have the structure. Now I just customize it.”
          </p>
        </div>
      </div>

      <CTAButton label="I want access to the complete system" data-id="element-289" data-mp="3s8r2wpq120gy" />
    </Section>;
}